import { frontendURL } from '../../../helper/URLHelper';

const ClaudiaLayout = () => import('./components/ClaudiaLayout.vue');
const EddieView = () => import('../eddie/pages/EddieView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/claudia'),
      name: 'claudia_app',
      component: ClaudiaLayout,
      meta: {
        permissions: ['administrator'],
      },
      children: [
        {
          path: '',
          redirect: 'view',
        },
        {
          path: 'view',
          name: 'eddie_view',
          component: EddieView,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
